/* SET STATE */
export const SET_STATE_TECHNICALADVISER = "SET_STATE_TECHNICALADVISER"

/* TECHNICAL ADVISERS */
export const GET_TECHNICALADVISERS = "GET_TECHNICALADVISERS"
export const GET_TECHNICALADVISERS_SUCCESS = "GET_TECHNICALADVISERS_SUCCESS"
export const GET_TECHNICALADVISERS_FAIL = "GET_TECHNICALADVISERS_FAIL"

/* TECHNICAL ADVISER */
export const GET_TECHNICALADVISER = "GET_TECHNICALADVISER"
export const GET_TECHNICALADVISER_SUCCESS = "GET_TECHNICALADVISER_SUCCESS"
export const GET_TECHNICALADVISER_FAIL = "GET_TECHNICALADVISER_FAIL"

/**
 * ADD TECHNICAL ADVISER
 */
 export const ADD_NEW_TECHNICALADVISER = "ADD_NEW_TECHNICALADVISER"
 export const ADD_TECHNICALADVISER_SUCCESS = "ADD_TECHNICALADVISER_SUCCESS"
 export const ADD_TECHNICALADVISER_FAIL = "ADD_TECHNICALADVISER_FAIL"

 /**
 * UPDATE TECHNICAL ADVISER
 */
export const UPDATE_TECHNICALADVISER = "UPDATE_TECHNICALADVISER"
export const UPDATE_TECHNICALADVISER_STATUS = "UPDATE_TECHNICALADVISER_STATUS"
export const UPDATE_TECHNICALADVISER_SUCCESS = "UPDATE_TECHNICALADVISER_SUCCESS"
export const UPDATE_TECHNICALADVISER_FAIL = "UPDATE_TECHNICALADVISER_FAIL"

/**
 * DELETE TECHNICAL ADVISER
 */
export const DELETE_TECHNICALADVISER = "DELETE_TECHNICALADVISER"
export const DELETE_TECHNICALADVISER_SUCCESS = "DELETE_TECHNICALADVISER_SUCCESS"
export const DELETE_TECHNICALADVISER_FAIL = "DELETE_TECHNICALADVISER_FAIL"

export const UPDATE_TECHNICALADVISER_CHECK = "UPDATE_TECHNICALADVISER_CHECK"
